/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_CALENDER_DATA, CALENDER_DATA_RECEIVED } = constants.calenderDataConstants;

export default {
    REQUEST_CALENDER_DATA,
    CALENDER_DATA_RECEIVED,

  requestCalenderData: payload => ({
    type: REQUEST_CALENDER_DATA,
    payload
  }),
  CalenderDataReceived: () => ({
    type: CALENDER_DATA_RECEIVED
  }),
};
